import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";

import {EmailIcon} from "../../styles/icons";
import useUser from '../../hooks/useUser';
import ViewMessageThreadDialog from './ViewMessageThreadDialog';

const ViewMessagesButton = props => {
  const {iconOnly, textOnly, isPatient} = props;
  const navigate = useNavigate();
  const user = useUser();
  const [dialogOpen, setDialogOpen] = useState(false);
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const providerId = (
    isString(props.providerId) || isNumber(props.providerId)
    ? props.providerId
    : get(props, 'provider.id')
  ) || '';
  const onClick = () => {
    if (user?.is_provider && patientId) {
      setDialogOpen(true);
    } else {
      // Patients navigate to ListMessagesPage
      navigate('/clients/messages');
    }
  };
  const childProps = {
    onClick,
    sx: props.sx,
    disabled: !patientId && !providerId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <EmailIcon />,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  return (
    <>
      {user?.is_provider && patientId && (
        <ViewMessageThreadDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          patientId={patientId}
        />
      )}
      {iconOnly
      ? <Tooltip title='Message'>
        <IconButton {...childProps}>
          <EmailIcon fill={props.fill || 'var(--primary)'}/>
        </IconButton>
      </Tooltip>
      : <Button {...childProps}>
          Message
      </Button>
      }
    </>
  );
};

ViewMessagesButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

ViewMessagesButton.propTypes = {
  provider: PropTypes.object,
  providerId: PropTypes.object,
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default ViewMessagesButton;
